import { config } from '../config';
import { addAuthHeader } from './auth';
import { Language } from '../types/preferences';
import { ResponseMetadata } from '#/types/message';

export interface Response {
  response_text: string;
  sound_file_name: string;
  metadata: ResponseMetadata;
  telemetry_response: boolean;
}

export async function sendPrompt(
  sessionId: string,
  promptText: string,
  language: Language,
  muted: boolean) {
  const response = await fetch(
    `${config.backendUrl}/prompt`,
    {
      method: 'POST',
      headers: await addAuthHeader({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        'session_id': sessionId,
        'prompt': promptText,
        'language': language,
        'muted': muted
      })
    })
  const data: Response = await response.json();
  return data;
}